import { combineReducers } from 'redux';
import scratchTicketReducer from './scratchTicketReducer';
import scratchBuyTicketReducer from './scratchBuyTicketReducer';
import scratchMyTicketReducer from './scratchMyTicketReducer';
import scratchTicketDataReducer from './scratchTicketDataReducer';
import scratchedTicketReducer from './scratchedTicketReducer';
import scratchedTicketDrawReducer from './scratchedTicketDrawReducer';

export default combineReducers({
  scratchTickets: scratchTicketReducer,
  scratchBuyTickets: scratchBuyTicketReducer,
  scratchMyTickets: scratchMyTicketReducer,
  scratchTicketData: scratchTicketDataReducer,
  scratchedTicket: scratchedTicketReducer,
  scratchedTicketDraw: scratchedTicketDrawReducer
});
